import { render, staticRenderFns } from "./AdminNewLab.vue?vue&type=template&id=d617788e&"
import script from "./AdminNewLab.vue?vue&type=script&lang=js&"
export * from "./AdminNewLab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports